const CONFIG = {
  userPoolId: "us-east-2_sqnfkoKvT",
  clientId: "5ui3jqnqah7rjkaetncspnhuoe",
  region: "us-east-2",
  apiUrl: "https://ppt9v5ut53.execute-api.us-east-2.amazonaws.com/prod",
};

export default CONFIG;
